import { Component, OnDestroy, Inject, OnInit, ViewChild } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { AolService } from '../../services/aol';
import {
  takeUntil,
  delay,
  map,
  tap,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { SharedValidators } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
import {
  OptionService,
  OptionTypeService,
} from 'src/modules/features/setting/services';
interface ICompanyInfoModalContext {
  title?: string;
  documentName: any;
}
@Component({
  selector: 'app-new-edit-shares-edit-component-modal-modal',
  templateUrl: './edit-document-component.html',
  styleUrls: ['./edit-document-component.scss'],
})
export class EditDocumentnameModalComponent implements OnInit, OnDestroy {
  @ViewChild('captchaRef') refCapt;
  private unsubscribe$: Subject<void> = new Subject<void>();
  companyDetail: any;
  success: any;
  public loginPending: boolean;
  public detailForm: FormGroup;
  public pending: boolean;
  public formSubmitAttempt = false;
  public bppDetail: any;
  public error: any;
  public countries: any;
  public states: any;
  public mode = 'year';
  public max = new Date();

  public companyEmailLoading = false;
  public usernameLoading = false;
  public emailLoading = false;

  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filter: AppFilter = new AppFilter();
  optionType;
  lookupTemplates;
  extraData;
  DataEdit;
  organizationId;
  shareAmount;
  documentsType;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyInfoModalContext, void, void>,
    private http: HttpClient,
    private organizationSvc: OrganizationService,
    private optionTypeSvc: OptionTypeService,
    private AolService: AolService,
    private optionSvc: OptionService
  ) {
    this.documentsType =
      this.modal.context.documentName.document.documentTypeId;
    console.log(modal.context.documentName.document);
    this.organizationId = window.localStorage.getItem('organizationId');
    this.detailForm = this.fb.group({
      documentName: [
        modal.context.documentName.document.documentName,
        [Validators.required],
      ],
    });
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupTemplates = res.rows;
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  ngOnDestroy() {}
  ngOnInit() {}
  submit() {
    this.pending = true;
    this.AolService.submitCompanyDetails({
      body: {},
      documentName: this.detailForm.value.documentName,
      supportingdocumentId:
        this.modal.context.documentName.supportingDocumentId,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Document Name Updated Successfully';
        setTimeout(() => {
          this.modal.approve();
        }, 2000);
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }
  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
}
export class EditDocumentsModal extends ComponentModalConfig<
  ICompanyInfoModalContext,
  void,
  void
> {
  constructor(
    title: string,
    documentName: string,
    size: ModalSize = ModalSize.Mini
  ) {
    super(EditDocumentnameModalComponent, { title, documentName });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
